import { Component } from '@angular/core'
import { ToastrService, ToastPackage } from 'ngx-toastr'

@Component({
  selector: 'app-custom-toastr',
  templateUrl: './custom-toastr.component.html',
  styleUrls: ['./custom-toastr.component.scss'],
  standalone: true,
  imports: []
})
export class CustomToastrComponent {
  data = {
    type: 'error',
    message: ''
  }
  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage
  ) {}
}
